<template>
  <Modal
	v-model="isShow"
  :width="700"
  :loading="loading"
  :mask-closable="false"
  @on-ok="ok"
  >
		<h3 slot="header" class="modal-header">活动详情</h3>
		<Form class="page-wrapper" v-if="item">
			<Row :gutter="5" >
				<Col span='20'>
					<FormItem label="项目名称：">
						<span>{{item.projectName}}</span>
					</FormItem>
				</Col>
			</Row>
			<Row :gutter="5">
				<Col span='10'>
					<FormItem label="活动名称：">
						<span>{{item.activityName}}</span>
					</FormItem>
				</Col>
				<Col span='10'>
					<FormItem label="活动时间：">
						<span>{{item.activityDate}}</span>
					</FormItem>
				</Col>
			</Row>
			<Row :gutter="5" v-for="(item1,index1) in item.activityTypeDtos" :key="index1">
				<Col span='10'>
					<FormItem :label="item1.typeName+'：'">
						<span>{{item1.zoNames}}</span>
					</FormItem>
				</Col>
				<Col span='10'>
					<FormItem label="计分：">
						<span>{{item1.score}}</span>
					</FormItem>
				</Col>
			</Row>
			<Row :gutter="5">
				<Col span='10'>
					<FormItem label="描述：">
						<span>{{item.descript}}</span>
					</FormItem>
				</Col>
			</Row>
			<Row :gutter="2">
				<Col span='10'>
					<FormItem label="审核状态：">
						<span>{{item.auditStatusName}}</span>
					</FormItem>
				</Col>
				<Col span='10' v-if="item.auditStatus">
					<FormItem label="审核人：">
						<span>{{item.auditZo}}</span>
					</FormItem>
				</Col>
			</Row>
			<Row :gutter="2" v-if="item.auditStatus">
				<Col span='10'>
					<FormItem label="备注：">
						<span>{{item.remark}}</span>
					</FormItem>
				</Col>
			</Row>
			<Row :gutter="2" v-if="item.auditStatus">
				<Col span='10'>
					<FormItem label="审核时间：">
						<span>{{item.auditDate}}</span>
					</FormItem>
				</Col>
			</Row>
			<Row>
				<Col span="30">
          <FormItem label="附件：">
						<img @click="showImg(item2.imgUrl)" v-for="(item2,index2) in item.imagesDtos" :key="index2" :src="item2.imgUrl" class="upload">
          </FormItem>
        </Col>
			</Row>
		</Form>
		<img-show :src="imgSrc" :n="showImgKey"></img-show>
  </Modal>
</template>

<script>
import { formatDateTime } from "../../../../../../utils/format";
import {findActivityDetail} from 'api/activityManageApi'
import ImgShow from 'components/ImgShow/index'

export default {
	components:{
		ImgShow,
	},
	props:{
		c:{
			type:Number,
			default:0,
		},
		activityFid:{
      type: String,
      default: '',
    },
	},
	data(){
		return{
			item:[],
			loading:false,
			isShow:false,
			imgSrc:'',
			showImgKey:0,
		}
	},
	watch:{
		c(){
			this.isShow = true;
			findActivityDetail({
        activityFid:this.activityFid
			})
			.then(res=>{
				this.item = res.data
				if(this.item){
					this.item.activityDate = this.format(this.item.activityDate)
					this.item.auditDate = this.format(this.item.auditDate)
				}
			})
		}
	},
	methods:{
		ok(){

		},
		showImg(data) {
			this.imgSrc = data
			this.showImgKey++
		},
		format(data, showTime = true) {
      if (!data) {
        return ''
      }
      return formatDateTime(data, showTime)
    },
	}
}
</script>

<style scoped>
.upload {
		display: block;
    width: 150px;
    height: 85px;
		border: 1px dashed rgb(220, 220, 220);
		margin: 0 10px 10px 0;
		float: left;
  }

		form-item{
			height: 10px;
		}

</style>